import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=337a9b6c&"
import script from "./Invoice.vue?vue&type=script&lang=js&"
export * from "./Invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337a9b6c')) {
      api.createRecord('337a9b6c', component.options)
    } else {
      api.reload('337a9b6c', component.options)
    }
    module.hot.accept("./Invoice.vue?vue&type=template&id=337a9b6c&", function () {
      api.rerender('337a9b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Invoice.vue"
export default component.exports